import { IconDefinition, IconPrefix, IconName } from "@fortawesome/fontawesome-common-types";

export const prefix: IconPrefix = 'far';
export const iconName: IconName = 'book-blank';
export const width: number = 448;
export const height: number = 512;
export const ligatures: (string)[] = ["128212"];
export const unicode: string = 'f02d';
export const svgPathData: string = 'M435.1 399.7c-4.2 13-4.2 51.6 0 64.6 7.3 1.4 12.9 7.9 12.9 15.7v16c0 8.8-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V80C0 35.8 35.8 0 80 0h352c8.8 0 16 7.2 16 16v368c0 7.8-5.5 14.2-12.9 15.7zm-41.1.3H80c-17.6 0-32 14.4-32 32 0 17.7 14.3 32 32 32h314c-2.7-17.3-2.7-46.7 0-64zm6-352H80c-17.7 0-32 14.3-32 32v278.7c9.8-4.3 20.6-6.7 32-6.7h320V48z'
export const aliases: (string | number)[] = [128212];
export const definition: IconDefinition = {
    prefix: prefix,
    iconName: iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData
    ]
};
export const faBookBlank: IconDefinition = definition;
